/**
 * Created by Jerker Nord on 2019-06-14.
 */
import {BaseController} from "@nolimitcity/slot-game/bin/core/base/BaseController";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {TimelineLite, TimelineMax, TweenLite} from "gsap";
import {ThorReelAreaView} from "../reel/ThorReelAreaView";
import {ThorBackground} from "../background/ThorBackground";
import {ThorReelBackgroundAreaView} from "../reel/reelbackground/ThorReelBackgroundAreaView";
import {ThorReelsFrame} from "../reel/reelframe/ThorReelsFrame";
import {ThorFreeSpinBoxView} from "../reel/freespinbox/ThorFreeSpinBoxView";
import {ThorLogo} from "../logo/ThorLogo";
import {ThorExtraFSIconView} from "../featureIcons/extraFSIcon/ThorExtraFSIconView";
import {ThorMultiplierIconView} from "../featureIcons/multipliericon/ThorMultiplierIconView";
import {ThorRandomWildIconView} from "../featureIcons/randomwildicon/ThorRandomWildIconView";
import {ThorReelWildIconView} from "../featureIcons/reelwildicon/ThorReelWildIconView";

export class ThorGameShaker extends BaseController {

    public static readonly START_GAME_SHAKING_SMALL:string = "iceIceYetiGameShaker_startGameShakingSmall";
    public static readonly START_GAME_SHAKING_BIG:string = "iceIceYetiGameShaker_startGameShakingBig";
    public static readonly START_GAME_SHAKING_REEL_AREA:string = "iceIceYetiGameShaker_startGameShakingReelArea";
    public static readonly STOP_GAME_SHAKING:string = "iceIceYetiGameShaker_stopGameShaking";

    private _smallShakeTL:TimelineMax;
    private _bigShakeTL:TimelineMax;
    private _reelAreaShakeTL:TimelineMax;
    private _stopped:boolean = true;

    constructor() {
        super();
        this.addEventListeners();
    }

    private addEventListeners():void {
        EventHandler.addEventListener(this, ThorGameShaker.START_GAME_SHAKING_SMALL, (event:GameEvent) => this.onStartGameShakingSmall());
        EventHandler.addEventListener(this, ThorGameShaker.START_GAME_SHAKING_BIG, (event:GameEvent) => this.onStartGameShakingBig());
        EventHandler.addEventListener(this, ThorGameShaker.START_GAME_SHAKING_REEL_AREA, (event:GameEvent) => this.onStartGameShakingReelArea());
        EventHandler.addEventListener(this, ThorGameShaker.STOP_GAME_SHAKING, (event:GameEvent) => this.onStopShakingGame());
    }

    private createSmallShakeAnimation():void {
        this._smallShakeTL = new TimelineMax({paused : true});
     //   this._smallShakeTL.add(this.createShakeAnimation(ThorBackground.thorBackground, 0.04, 3.4));
        this._smallShakeTL.add(this.createShakeAnimation(ThorExtraFSIconView.thorExtraFSIconView, 0.04, 3.4));
        this._smallShakeTL.add(this.createShakeAnimation(ThorMultiplierIconView.thorMultiplierIconView, 0.04, 3.4));
        this._smallShakeTL.add(this.createShakeAnimation(ThorRandomWildIconView.thorRandomWildIconView, 0.04, 3.4));
        this._smallShakeTL.add(this.createShakeAnimation(ThorReelWildIconView.thorReelWildIconView, 0.04, 3.4));
        this._smallShakeTL.add(this.createShakeAnimation(ThorLogo.thorLogo, 0.04, 3.4));
        this._smallShakeTL.add(this.createShakeAnimation(ThorReelBackgroundAreaView.thorReelBackgroundAreaView, 0.04, 3.4));
        this._smallShakeTL.add(this.createShakeAnimation(ThorReelsFrame.thorReelsFrame, 0.04, 3.4));
        this._smallShakeTL.add(this.createShakeAnimation(ThorFreeSpinBoxView.thorFreeSpinBoxView, 0.04, 3.4));
        this._smallShakeTL.add(this.createShakeAnimation(ThorReelAreaView._reelAreaView, 0.02, 3.4));
    }

    private createBigShakeAnimation():void {
        this._bigShakeTL = new TimelineMax({paused : true});
       // this._bigShakeTL.add(this.createShakeAnimation(ThorBackground.thorBackground, 0.04, 9.4));
        this._bigShakeTL.add(this.createShakeAnimation(ThorExtraFSIconView.thorExtraFSIconView, 0.04, 9.4));
        this._bigShakeTL.add(this.createShakeAnimation(ThorMultiplierIconView.thorMultiplierIconView, 0.04, 9.4));
        this._bigShakeTL.add(this.createShakeAnimation(ThorRandomWildIconView.thorRandomWildIconView, 0.04, 9.4));
        this._bigShakeTL.add(this.createShakeAnimation(ThorReelWildIconView.thorReelWildIconView, 0.04, 9.4));
        this._bigShakeTL.add(this.createShakeAnimation(ThorLogo.thorLogo, 0.04, 9.4));
        this._bigShakeTL.add(this.createShakeAnimation(ThorReelBackgroundAreaView.thorReelBackgroundAreaView, 0.04, 9.4));
        this._bigShakeTL.add(this.createShakeAnimation(ThorReelsFrame.thorReelsFrame, 0.04, 9.4));
        this._bigShakeTL.add(this.createShakeAnimation(ThorFreeSpinBoxView.thorFreeSpinBoxView, 0.04, 9.4));
        this._bigShakeTL.add(this.createShakeAnimation(ThorReelAreaView._reelAreaView, 0.02, 9.4));
    }

    private createReelAreaShakeAnimation():void {
        this._reelAreaShakeTL = new TimelineMax({paused : true});
        this._reelAreaShakeTL.add(this.createShakeAnimation(ThorReelBackgroundAreaView.thorReelBackgroundAreaView, 0.02, 2));
        this._reelAreaShakeTL.add(this.createShakeAnimation(ThorReelsFrame.thorReelsFrame, 0.06, 2));
        this._reelAreaShakeTL.add(this.createShakeAnimation(ThorReelAreaView._reelAreaView, 0.02, 2));
    }

    private onStartGameShakingSmall():void {
        if(!this._smallShakeTL) {
            this.createSmallShakeAnimation();
        }
        this._stopped = false;
        this._smallShakeTL.restart();
    }

    private onStartGameShakingBig():void {
        if(!this._bigShakeTL) {
            this.createBigShakeAnimation();
        }
        this._stopped = false;
        this._bigShakeTL.restart();
    }

    private onStartGameShakingReelArea():void {
        if(!this._reelAreaShakeTL) {
            this.createReelAreaShakeAnimation()
        }
        this._stopped = false;
        this._reelAreaShakeTL.restart();
    }

    private onStopShakingGame():void {
        if(this._smallShakeTL) {
            this._smallShakeTL.pause();
            this._smallShakeTL.kill();
        }
        if(this._bigShakeTL) {
            this._bigShakeTL.pause();
            this._bigShakeTL.kill();
        }
        if(this._reelAreaShakeTL) {
            this._reelAreaShakeTL.pause();
            this._reelAreaShakeTL.kill();
        }
        this._stopped = true;
    }

    private createShakeAnimation(layer:PIXI.DisplayObject, frequency:number, maxOffset:number):TimelineLite {
        this._stopped = false;
        if(maxOffset < 0.2) {
            maxOffset = 0.2;
        }
        let animation:TimelineLite = new TimelineLite();
        animation.add(TweenLite.fromTo(layer, frequency,
            {
                x : layer.x + ThorGameShaker.getShakeOffset(maxOffset),
                y : layer.y + ThorGameShaker.getShakeOffset(maxOffset),
            },
            {
                x : layer.x,
                y : layer.y,
                onComplete : () => {
                    if(this._stopped) {
                        return;
                    }
                    animation = this.createShakeAnimation(layer, frequency, maxOffset -= 0.2);
                },
                clearProps : "x,y"
            })
        );

        return animation;
    }

    private static getShakeOffset(offset:number):number {
        return Math.floor(Math.random() * (offset + offset + 1) - offset);
    }
}